export default {
  EMPTY: "empty",
  NOT_EMPTY: "non-empty",
  FOCUSED: "focused",
}
